// export const groceryData = [
//   {
//     id: "01",
//     title: "Build Your Order",
//     description: "Customize your box & set a schedule of recurring deliveries",
//   },
//   {
//     id: "02",
//     title: "Save Even More",
//     description: "Get extra 5-10% off thousands of products an Autoship",
//   },
//   {
//     id: "03",
//     title: "You’re In Control",
//     description:
//       "Edit items, skip or pause Autoship, or place one-time orders anytime",
//   },
// ];

export const groceryData = [
  {
    id: "01",
    title: "Monte seu pedido de compra",
    description: "Personalize sua comprar e contações de forma automática e defina um cronograma de entregas recorrentes",
  },
  {
    id: "02",
    title: "Economize ainda mais",
    description: "Economize em milhares de produtos no envio automático e agilize seu processo de compra e cotações automáticas",
  },
  {
    id: "03",
    title: "Você no controle",
    description:
      "Edite itens, pule ou pause o envio automático, ou faça pedidos avulsos a qualquer momento",
  },
];
